import { TableColumn, TableColumnType } from '@thehubz/client/core';
import { AssetMetadata } from '@thehubz/shared/model';
import { Channel, Subject } from './vorwerk-metadata-config';

export class VorwerkTableColumnData {
  /* Default table column configurations */
  static TABLE_DEFAULT_COLUMNS: TableColumn[] = [
    {
      sequence: 1,
      columnDef: 'checked',
      header: $localize`Checkbox`,
      type: TableColumnType.checkbox,
      class: 'w-[auto] grow-0',
      filter: false,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      sticky: true,
    },
    {
      sequence: 2,
      columnDef: 'previewUrl',
      header: $localize`Asset`,
      type: TableColumnType.assetPreview,
      class: 'w-[13vw] min-w-[9rem] pl-4 grow-0',
      filter: false,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 3,
      columnDef: 'name',
      header: $localize`Name`,
      class: 'w-[30rem] pl-4',
      filter: false,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 4,
      columnDef: 'assetType',
      header: $localize`:asset type:Type`,
      class: 'w-[9%] min-w-[9rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 5,
      columnDef: 'client',
      header: $localize`Location`,
      showValue: 'name',
      class: 'w-[9%] min-w-[9rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 6,
      columnDef: 'brand',
      header: $localize`Brand`,
      showValue: 'name',
      class: 'w-[8%] min-w-[8rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 7,
      columnDef: AssetMetadata.General.TAGS,
      type: TableColumnType.tags,
      header: $localize`Tags`,
      class: 'w-[12%] min-w-[12rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 8,
      columnDef: 'status',
      header: $localize`Status`,
      class: 'w-[8%] min-w-[8rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 9,
      columnDef: 'createdAt',
      type: TableColumnType.date,
      header: $localize`Created at`,
      class: 'w-[8%] min-w-[8rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 10,
      columnDef: 'createdBy',
      type: TableColumnType.createdByUserIcon,
      header: $localize`Created by`,
      class: 'w-[8%] min-w-[6rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 11,
      columnDef: 'expiryDate',
      type: TableColumnType.date,
      header: $localize`Expiry date`,
      class: 'w-[8%] min-w-[8rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
  ];
  /* Additional columns configurations */
  static ADD_COLUMNS: TableColumn[] = [
    {
      sequence: 1,
      columnDef: 'agency',
      header: $localize`Domain`,
      showValue: 'name',
      class: 'w-[10%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
    },
    {
      sequence: 2,
      columnDef: 'plannedDeletion',
      type: TableColumnType.date,
      header: $localize`Planned for deletion`,
      class: 'w-[8%] min-w-[6rem]',
      filter: true,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
    },
    {
      sequence: 3,
      columnDef: 'customFields',
      header: $localize`Channel`,
      showValue: 'channel',
      class: 'w-[10%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
      options: Channel,
    },
    {
      sequence: 4,
      columnDef: 'customFields',
      header: $localize`Subject`,
      showValue: 'subject',
      class: 'w-[10%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
      options: Subject,
    },
  ];
}
